var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 87.1 53.8",
    width: "87.1pt",
    height: "53.8pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_juQAY10P7NFXDE339PHesguRCbbuVZAB"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.1,
    height: 53.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_juQAY10P7NFXDE339PHesguRCbbuVZAB)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.775,
    y: 5.743,
    width: 23.549,
    height: 42.314,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,95,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 33.27 26.9 C 33.27 18.303 37.308 10.678 43.512 5.744 C 38.953 2.154 33.196 -0.014 26.916 -0.014 C 12.038 -0.014 0.002 12.023 0.002 26.9 C 0.002 41.778 12.038 53.814 26.916 53.814 C 33.196 53.814 38.953 51.646 43.512 48.057 C 37.308 43.198 33.27 35.497 33.27 26.9 Z ",
    fill: "rgb(235,0,27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 87.098 26.9 C 87.098 41.778 75.061 53.814 60.184 53.814 C 53.905 53.814 48.148 51.646 43.587 48.057 C 49.867 43.123 53.829 35.497 53.829 26.9 C 53.829 18.303 49.793 10.678 43.587 5.744 C 48.148 2.154 53.905 -0.014 60.184 -0.014 C 75.061 -0.014 87.098 12.097 87.098 26.9 Z ",
    fill: "rgb(247,158,27)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.44a3bb261a3b567fb4fa8bc81f54e9cc.svg";
export { ForwardRef as ReactComponent };